import React from 'react';
import ManageEntityList from './ManageEntityList';
import { useHeight } from '../../Services/HeightContext';
import entities from '../../utils/entities';
import ClientModal from '../Models/ClientModal';
import { Route } from 'react-router-dom';
import AdminDetail from '../Editors/AdminDetail';


const ManageCharterAdmins = ({ route,isNewItem }) => {
    const [height] = useHeight();
    return <React.Fragment> <ManageEntityList route={'/manageCharterAdmins'} parentHeight={height} entity={entities.charterAdmins} />
        <Route path='/manageCharterAdmins/:adminId' render={() => <ClientModal entity={entities.charterAdmins} route={route} itemParam='adminId'><AdminDetail invite={isNewItem} route={route} /></ClientModal>} />
    </React.Fragment>

}
export default ManageCharterAdmins;

